import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ButtonArrowed from '../Buttons/ButtonArrowed';

import './block-programs.scss';

class BlockPrograms extends PureComponent {
  render() {
    if (!this.props.content || !this.props.content.length) {
      return null;
    }

    return (
      <div className="block-programs">
        {this.props.content.map(({ link, label }, key) =>
          <ButtonArrowed key={key} direction="right" link={link}>
            <span dangerouslySetInnerHTML={{ __html: label }}/>
          </ButtonArrowed>
        )}
      </div>
    );
  }
}

BlockPrograms.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      label: PropTypes.string
    })
  )
};

export default BlockPrograms;



// WEBPACK FOOTER //
// ./src/components/widgets/Typography/BlockPrograms.js